// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"MyDay_gridWrapper__1M8f_","header":"MyDay_header__2amSM"};